import {
  Header,
  Main,
  Features,
  More,
  Integrations,
  FAQ,
  Pricing,
  Testimonials,
  Footer,
} from "./layouts/app";

function App() {
  return (
    <div>
      <Header />
      <Main />
      <Features />
      <More />
      <Integrations />
      <FAQ />
      <Pricing />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
